import React, { useCallback } from 'react';
import ResourceDefault from './ResourceSwitch/ResourceDefault';
import ObligationDefault from './ResourceSwitch/ObligationDefault';

export default function ElementContainer({ elementID, view }) {
  const ResourcesSwitch = useCallback(() => {
    switch (view) {
      default:
      case 'resource':
        return <ResourceDefault elementID={elementID} />;
      case 'obligation':
        return <ObligationDefault elementID={elementID} />;
    }
  }, [elementID, view]);

  return (
    <div className="pt-2">
      <ResourcesSwitch />
    </div>
  );
}
